import { render } from "./RiPin.vue?vue&type=template&id=640fce58"
import script from "./RiPin.vue?vue&type=script&lang=js"
export * from "./RiPin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiPin.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "640fce58"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('640fce58', __exports__)) {
    api.reload('640fce58', __exports__)
  }
  
  module.hot.accept("./RiPin.vue?vue&type=template&id=640fce58", () => {
    api.rerender('640fce58', render)
  })

}


export default __exports__